import React from 'react';
import classNames from 'classnames';

interface SegmentControlProps{
	selected: number[],
	segments: {
		value: number,
		text: string,
	}[],
	onClick: (ix: number)=>void,
}

var SegmentControl = (props: SegmentControlProps)=>{
	return <div className="fr segments">
		{props.segments.map(a=>(
			<div onClick={()=>props.onClick(a.value)} className={classNames('segment', {
				active: props.selected.indexOf(a.value)!=-1
			})} key={`SGMT-${a.value}`}>{a.text}</div>
		))}
	</div>
}

export default SegmentControl;